module.exports = __webpack_public_path__ + "img/banner-cd-cover.0e4a1c5d.jpeg";